import * as a from "./action";

export const getMerchants =
  () =>
  async (dispatch, getState, { history, remote }) => {
    try {
      const merchants = await remote(
        "get",
        "/v3/merchants/sell",
        {},
        "loading all the cool merchants we have to offer for selling gift cards",
        dispatch
      );

      if (merchants.message) {
        throw merchants;
      }

      dispatch(a.setMerchants(merchants.sellMerchants));
    } catch (error) {}
  };
